import config from "@/data/config";
import store from "@/store";

const env = {
  getters: {
    authMode() {
      return import.meta.env.VITE_AUTH_MODE || "onid";
    },
    isDebugMode() {
      return import.meta.env.VITE_DEBUG === "true";
    },
    useAuth() {
      return import.meta.env.VITE_DO_AUTH === "true";
    },
    useDatastore() {
      return import.meta.env.VITE_USE_DATASTORE === "true";
    },
    useLandingPage() {
      return config.settings.useLandingPage === true;
    },
    useNavbar() {
      return config.settings.useNavbar === true;
    },
    publicKey(state, getters) {
      let key = "";
      if (getters.authMode === "onid") {
        key = import.meta.env.VITE_PUBLIC_KEY;
      } else {
        let token = getters.getDecodedToken;
        key = token.aud || "";
      }
      return key;
    },
    getAchievementsApiKey() {
      let courseId = store.getters.getCourseId;

      if (courseId === import.meta.env.VITE_COURSE_ID1) {
        return import.meta.env.VITE_ACHIEVEMENTS_API_KEY1 || "";
      } else {
        return import.meta.env.VITE_ACHIEVEMENTS_API_KEY2 || "";
      }
    },
    getQuestionsApiKey() {
      let courseId = store.getters.getCourseId;

      if (courseId === import.meta.env.VITE_COURSE_ID1) {
        return import.meta.env.VITE_QUESTIONS_API_KEY1 || "";
      } else {
        return import.meta.env.VITE_QUESTIONS_API_KEY2 || "";
      }
    },
    getAwardedPointsApiKey() {
      let courseId = store.getters.getCourseId;

      if (courseId === import.meta.env.VITE_COURSE_ID1) {
        return import.meta.env.VITE_AWARDED_POINTS_API_KEY1 || "";
      } else {
        return import.meta.env.VITE_AWARDED_POINTS_API_KEY2 || "";
      }
    },
    getAchievementsGlossaryLink() {
      let courseId = store.getters.getCourseId;

      if (courseId === import.meta.env.VITE_COURSE_ID1) {
        return import.meta.env.VITE_ACHIEVEMENTS_LINK1 || "";
      } else {
        return import.meta.env.VITE_ACHIEVEMENTS_LINK2 || "";
      }
    },
    getQuestionsGlossaryLink() {
      let courseId = store.getters.getCourseId;

      if (courseId === import.meta.env.VITE_COURSE_ID1) {
        return import.meta.env.VITE_QUESTIONS_LINK1 || "";
      } else {
        return import.meta.env.VITE_QUESTIONS_LINK2 || "";
      }
    },
    getAwardedPointsGlossaryLink() {
      let courseId = store.getters.getCourseId;

      if (courseId === import.meta.env.VITE_COURSE_ID1) {
        return import.meta.env.VITE_AWARDED_POINTS_LINK1 || "";
      } else {
        return import.meta.env.VITE_AWARDED_POINTS_LINK2 || "";
      }
    }
  }
};

export default env;
